// Navbar.js
import React from 'react';
import { Link } from 'react-router-dom'; // If using React Router
import useAuth from '../hooks/useAuth';

const Navbar = () => {
  
  const currTime24 = new Date().toLocaleTimeString('en-US', { hour: '2-digit', hour12: false });
  const {auth} = useAuth();
  console.log(currTime24);
  function getGreeting(currTime24) {
    const hour = parseInt(currTime24, 10); // Ensure currTime24 is treated as a base 10 integer
    
    if (hour < 12) {
      return "Good Morning";
    } else if (hour >= 12 && hour < 18) {
      return "Good Afternoon";
    } else if (hour >= 18) {
      return "Good Evening";
    } else {
      return "Hello"; // Default case, though technically covered by the above conditions
    }
  }
  
  return (
    <nav className='bg-white flex flex-row h-[10dvh] justify-evenly items-center text-[0.8rem] gap-[10%] w-screen'>
      <Link className='h-full flex' to="/">      
      <img className='h-[35%] my-auto' src="/logo.png" alt=""/>
      </Link>


      <div className='h-full flex justify-center items-center gap-[10%] whitespace-nowrap' >      
        <Link className='bg-[#03236F] rounded-lg text-white flex items-center h-[50%] p-[4%]' to="/find">Find Project</Link>
        <Link className='text-[#03236F]' to="/post">Post Project</Link>
        <Link className='text-[#03236F]' to="/about">About Us</Link>
        <Link className='text-[#03236F]' to="/faq">FAQ</Link>
      </div>
      {auth.name==='' ? <Link to="/login" className='bg-[#E7EEFF] text-[#03236F] rounded-lg text-nowrap h-[50%] flex items-center py-[1.7%] px-[2%]'>Sign up /Login</Link> 
      :<div className='flex flex-row items-center gap-[2%] relative group cursor-pointer '>
         <img src="UserCircle.png" alt=""/>
         <p className='text-[1.1rem] text-left whitespace-nowrap'>{}{getGreeting(currTime24)},</p>
         <p className='text-[1.1rem] text-left whitespace-nowrap'> {auth.name}</p> 
         <div className='absolute h-[200%] w-full bg-white top-[240%] group-hover:top-[160%] rounded-md drop-shadow-[10px_35px_35px_rgba(0,0,0,0.25)] shadow-2xl flex flex-col justify-evenly invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-500'>
          <Link className='text-[1.1rem]'>Profile</Link>
          <hr className='bg-gray-500 w-[80%] self-center opacity-30'/>
          <p className='text-[1.1rem] cursor-pointer' onClick={()=>{localStorage.removeItem('accessToken'); window.location.reload(); return;}}>Log out</p>
         </div>
      </div>}
     
    </nav>
  );
};

export default Navbar;
